import calls from '@/backend/api-calls'

const state = () => ({
  requests: [],
  selected: [],
  allSelected: false,
  loading: false,
  pagination: {
    page: 1,
    pages: 1
  },
  filters: {
    request_reason: 'Project'
  },
  requestReasons: ['Project', 'Introduction']
})

// getters
const getters = {
  ids: state => {
    return state.requests.map(d => d.id);
  }
}

// actions
const actions = {
  getRequests: ({commit}, parameters) => {
    commit("setLoading", true);

    return new Promise((resolve, reject) => {
      calls.sampleRequests.get(parameters)
        .then(resp => {
          commit("setRequests", resp.data);
          commit("setLoading", false);
          resolve(resp);
        }).catch(err => {
          commit("setLoading", false);
          reject(err);
        })
    })
  },
  addRequest({commit}, data) {
    return new Promise((resolve, reject) => {
      calls.sampleRequests.post(data)
        .then(resp => {
          commit("insertRequest", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  updateRequest: ({commit}, { requestId, data }) => {
    return new Promise((resolve, reject) => {
      calls.sampleRequests.put(requestId, data).then(
        resp => {
          commit("insertUpdatedRequest", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Sample request successfully updated'
          }, { root: true });

          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  deleteRequest: ({commit}, requestId) => {
    return new Promise((resolve, reject) => {
      calls.sampleRequest.delete(requestId).then(
        resp => {
          commit("removeRequest", requestId);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Sample request successfully deleted'
          }, { root: true });

          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  addAttachment: ({commit}, {sampleRequestId, data}) => {
    return new Promise((resolve, reject) => {
      calls.sampleRequest.addAttachment(sampleRequestId, data).then(
        resp => {
          commit("insertUpdatedRequest", resp.data);
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  toggleAllSelected: ({commit, getters}, value) => {
    if (value) {
      commit("selectAll", getters.ids);
    } else {
      commit("deselectAll");
    }
  }
}

// mutations
const mutations = {
  setLoading(state, status) {
    state.loading = status;
  },
  setRequests(state, data) {
    state.pagination = data.pagination;
    state.requests = data.results;
  },
  insertRequest(state, data) {
    state.requests.push(data);
  },
  insertUpdatedRequest(state, data) {
    state.requests.forEach((request, i) => {
      if (request.id == data.id) {
        state.requests.splice(i, 1, data);
      }
    })
  },
  removeRequest(state, requestId) {
    state.requests.forEach((request, i) => {
      if (request.id == requestId) {
        state.requests.splice(i, 1);
      }
      const index = state.selected.indexOf(requestId);
      if (index != -1) {
        state.selected.splice(index, 1);
      }
    })
  },
  changePage(state, page) {
    state.pagination.page = page;
  },
  setFilter(state, { field, value }) {
    state.filters[field] = value;
  },
  // insertOrderDetail(state, orderDetail) {
  //   state.orders.forEach(order => {
  //     if (order.id == orderDetail.order_id) {
  //       order.details.push(orderDetail);
  //     }
  //   })
  // },
  selectAll(state, ids) {
    state.allSelected = true;
    ids.forEach(id => {
      if (state.selected.indexOf(id) == -1) {
        state.selected.push(id);
      }
    })
  },
  deselectAll(state) {
    state.allSelected = false;
    state.selected.splice(0, state.selected.length)
  },
  toggleSelected(state, id) {
    const index = state.selected.indexOf(id);

    if (index == -1) {
      state.selected.push(id);
    } else {
      state.selected.splice(index, 1);
      if (state.selected.length == 0) {
        state.allSelected = false;
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}